import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cmps-insight-coaching-commitment',
    template: `
        <div class="cmps-insight-coaching-commitment--exclamation-point">
            <cmps-icon
                class="cmps-insight-coaching-commitment--circle"
                [style.backgroundColor]="color"
                svgIcon="__internal:exclamation-thick"
            ></cmps-icon>
        </div>
        <div class="cmps-insight-coaching-commitment--info">
            <h5 class="cmps-insight-coaching-commitment--commitment">
                {{ commitmentValue }}
            </h5>
            <p class="cmps-insight-coaching-commitment--date">{{ date }}</p>
        </div>
        <div class="cmps-insight-coaching-commitment--hover-info">
            <button
                cmpsButton
                (click)="infoAction.emit($event)"
            >
                <cmps-icon svgIcon="__internal:information-outline"></cmps-icon>
            </button>
        </div>
    `,
    host: {
        class: 'cmps-insight-coaching-commitment',
    },
})
export class CmpsInsightCoachingCommitmentComponent {
    @Input() commitmentValue: string;
    @Input() date: string;
    @Input() color: string;
    @Output() infoAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.infoAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.infoAction.complete();
    }
}
